import { Avatar, Divider, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import timeIcon from "assets/icons/group-4.png";
import React from "react";
import { useSelector } from "react-redux";
import MuiStylesProfessionalDiv from "~/components/common/professionalDiv/MuiStylesProfessionalDiv";
import { useTranslation } from "react-i18next";
import Utils from "~/helpers/Utils";

const getInitials = (name) => {
	if (!name) return "?";
	const parts = name.trim().split(/\s+/);
	if (parts.length === 1) return parts[0][0].toUpperCase();
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ProfessionalDiv = (props) => {
	const { index, professional, isPackage, priceServicePackage } = props;

	const { business } = useSelector((store) => store.business);

	const { t } = useTranslation();

	const classes = MuiStylesProfessionalDiv();

	const margin = index === 0 ? "4px 0 20px" : "20px 0";

	const currency = business?.currency;

	const priceService = (priceServicePackage) => {
		if (isPackage) {
			return priceServicePackage;
		}
		return professional?.price;
	}

	const convert = (minutes) => {
		const hours = Math.floor(minutes / 60);
		const min = minutes % 60;
		const textHours = `${hours}`.slice(-2);
		const textMin = `00${min}`.slice(-2);

		return textHours === "0" ? ` ${textMin}m` : `${textHours}h ${textMin}m`;
	};

	return (
		<>
			{props.professionalView ? (
				<div key={`professional-${index}`} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
					<div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
						<div style={{ marginRight: "15px" }}>
							<Avatar
								alt={professional.name}
								src={professional.avatarUrl || undefined}
								style={{ backgroundColor: "#9E9E9E", width: 40, height: 40, fontSize: 16 }}>
								{!professional.avatarUrl && getInitials(professional.name)}
							</Avatar>
						</div>
						<div style={{ paddingBottom: "10px", flex: 1 }}>
							<Typography style={{ fontSize: "clamp(18px, 1vw, 20px)", fontWeight: "500" }}>{professional.name ?? "Sem nome"}</Typography>
							{/* <Typography className={clsx({ [classes.subtitle]: true })}>{sector}</Typography> */}
							<div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap:4 }}>
								<Typography translate="no" className={classes.time}>
									<img src={timeIcon} alt="Horário" style={{ width: "12px", height: "12px" }}/>
									<span style={{ fontWeight: 500, paddingLeft: "5px" }}>
										{convert(professional?.duration)}
									</span>
									{" - "}
								</Typography>
								<Typography className={classes.price}>
									{`${
										(professional?.pricing_type || professional?.pricingType) &&
										Utils.dontShowPricingTypeNames.includes(professional?.pricing_type || professional?.pricingType)
											? t("Upon consultation")
											: `${
												!Utils.fixedPricingTypeNames.includes(professional?.pricing_type || professional?.pricingType)
														? Utils.startsAtPricingTypeNames.includes(professional?.pricing_type || professional?.pricingType)
															? t("Starts at")
															: (professional?.pricing_type || professional?.pricingType)
														: ""
											  } ${
												!Utils.freePricingTypeNames.includes(professional?.pricing_type || professional?.pricingType)
														? Utils.formatMoney((priceService(priceServicePackage) / 100), currency)
														: ""
											  }`
									}`}
								</Typography>
							</div>
						</div>
					</div>
				</div>
			) : (
				<>
					<div key={`professional-${index}`} style={{ display: "flex", flexDirection: "row", margin }}>
						<Avatar
							alt={professional.name}
							src={professional.avatarUrl || undefined}
							style={{ backgroundColor: "#9E9E9E", width: 40, height: 40, fontSize: 16 }}>
							{!professional.avatarUrl && getInitials(professional.name)}
						</Avatar>
						<div style={{ marginLeft: "20px" }}>
							<Typography style={{ fontSize: "16px", fontWeight: "500" }}>{professional.name}</Typography>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default ProfessionalDiv;
